import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import { BasicRegulationFieldsFragmentDoc, BasicRegulatoryDocumentFieldsFragmentDoc, BasicRequirementFieldsFragmentDoc, BasicPogisFieldsFragmentDoc, BasicRegulatoryDocumentParaFieldsFragmentDoc } from '../../../fragments/basicFields.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FullTextSearchRegulationsQueryVariables = Types.Exact<{
  searchString: Types.Scalars['String'];
  limit?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type FullTextSearchRegulationsQuery = { __typename?: 'Query', searchRegulations: { __typename?: 'FullTextRegulationResult', regulations: Array<{ __typename?: 'Regulation', id: string, regulationNumber: string, name: string, summary: string, markets: Array<{ __typename?: 'Market', id: string, name: string }>, mainKeywords: Array<{ __typename?: 'Keyword', id: string, name: string }>, keywords: Array<{ __typename?: 'Keyword', id: string, name: string, sortPriority?: number | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, vkos: Array<{ __typename?: 'User', id: string, name: string }> }>, standardPlusPcmsClusters: Array<{ __typename?: 'StandardPlusPcmsCluster', id: string, name: string }>, contactPersons: Array<{ __typename?: 'User', name: string, id: string }> }> } };

export type FullTextSearchRegulatoryDocumentsQueryVariables = Types.Exact<{
  searchString: Types.Scalars['String'];
  limit?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type FullTextSearchRegulatoryDocumentsQuery = { __typename?: 'Query', searchRegulatoryDocuments: { __typename?: 'FullTextRegulatoryDocumentResult', regulatoryDocuments: Array<{ __typename?: 'RegulatoryDocument', id: string, name: string, status: Types.RegulatoryDocumentStatus, summary?: string | null, modelYear?: number | null, dateEffective?: any | null, dateExpiration?: any | null, dateNewRegistration?: any | null, dateNewTypes?: any | null, regulation?: { __typename?: 'Regulation', name: string, regulationNumber: string } | null, markets: Array<{ __typename?: 'Market', id: string, name: string }>, keywords: Array<{ __typename?: 'Keyword', id: string, name: string, sortPriority?: number | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, vkos: Array<{ __typename?: 'User', id: string, name: string }> }>, mainKeywords: Array<{ __typename?: 'Keyword', id: string, name: string }>, contactPersons: Array<{ __typename?: 'User', name: string, id: string }>, vehicleCategories: Array<{ __typename?: 'VehicleCategory', id: string, name: string }>, driveVariants: Array<{ __typename?: 'DriveVariant', id: string, name: string }>, workflow: { __typename?: 'Workflow', status: Types.WorkflowStatus }, phaseOut: Array<{ __typename?: 'PhaseDate', date?: any | null, status?: string | null }>, phaseIn: Array<{ __typename?: 'PhaseDate', date?: any | null, status?: string | null }> }> } };

export type FullTextSearchRequirementsQueryVariables = Types.Exact<{
  searchString: Types.Scalars['String'];
  limit?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type FullTextSearchRequirementsQuery = { __typename?: 'Query', searchRequirements: { __typename?: 'FullTextRequirementResult', requirements: Array<{ __typename?: 'Requirement', id: string, name: string, status: Types.RequirementStatus, definition?: string | null, requirementId?: string | null, markets: Array<{ __typename?: 'Market', id: string, name: string }>, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, driveVariants: Array<{ __typename?: 'DriveVariant', id: string, name: string }>, engineVariants: Array<{ __typename?: 'EngineVariant', id: string, name: string }>, gearboxVariants: Array<{ __typename?: 'GearboxVariant', id: string, name: string }>, bodyworkVariants: Array<{ __typename?: 'BodyworkVariant', id: string, name: string }>, activeTypeMarkets: Array<{ __typename?: 'ActiveTypeMarket', id: string, name: string }>, vehicleCategories: Array<{ __typename?: 'VehicleCategory', id: string, name: string }>, keywords: Array<{ __typename?: 'Keyword', id: string, name: string }>, systemLevels: Array<{ __typename?: 'SystemLevel', id: string, name: string }>, createdBy: { __typename?: 'User', name: string, id: string } }> } };

export type FullTextSearchPogisQueryVariables = Types.Exact<{
  searchString: Types.Scalars['String'];
  limit?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type FullTextSearchPogisQuery = { __typename?: 'Query', searchPogisDocuments: { __typename?: 'FullTextPogisDocumentResult', pogisDocuments: Array<{ __typename?: 'PogisDocument', associations?: Array<string> | null, createdAt?: any | null, docStatus: string, editor: string, id: string, keywords: Array<string>, linkVersion?: string | null, markets: Array<string>, modifiedAt?: any | null, pogisId: string, regulationStatus: string, relatedDocuments?: Array<string> | null, shortInfo: string, standards?: Array<string> | null, pogisAttachments?: Array<{ __typename?: 'AttachmentRef', attachmentId: string, file: { __typename?: 'BlobRef', fileName: string, uri: any }, category?: { __typename?: 'AttachmentCategory', name: string } | null }> | null, dates: Array<{ __typename?: 'PogisDate', date: any, dateType: string }> }> } };

export type DeepSearchParagraphsQueryVariables = Types.Exact<{
  searchString: Types.Scalars['String'];
}>;


export type DeepSearchParagraphsQuery = { __typename?: 'Query', searchParagraphs: { __typename?: 'FullTextParagraphsResult', regulatoryDocumentsOtherData: Array<{ __typename?: 'RegulatoryDocument', id: string, name: string, regulation?: { __typename?: 'Regulation', id: string, name: string, regulationNumber: string } | null, paragraphs: Array<{ __typename?: 'RegulatoryDocumentParagraph', level: number, id: string, enumeration: string }> }>, regulatoryDocumentsSearchedPara: Array<{ __typename?: 'RegulatoryDocument', id: string, paragraphs: Array<{ __typename?: 'RegulatoryDocumentParagraph', level: number, id: string, enumeration: string, modelYear?: number | null, comprehensive?: any | null, dateNewRegistration?: any | null, dateNewTypes?: any | null, position: number, keywords: Array<{ __typename?: 'Keyword', id: string, name: string, sortPriority?: number | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, vkos: Array<{ __typename?: 'User', id: string, name: string }> }>, categories: Array<{ __typename?: 'Category', id: string, name: string }>, driveVariants: Array<{ __typename?: 'DriveVariant', id: string, name: string }>, vehicleCategories: Array<{ __typename?: 'VehicleCategory', id: string, name: string }>, phaseIn?: Array<{ __typename?: 'PhaseDate', date?: any | null, status?: string | null }> | null, phaseOut?: Array<{ __typename?: 'PhaseDate', date?: any | null, status?: string | null }> | null, elements: Array<{ __typename?: 'RegulatoryDocumentParagraphElement', assetId?: string | null, bounds?: Array<number> | null, csvContent?: string | null, isHeader: boolean, page: number, text?: string | null, textPosition?: Types.TextPosition | null, type: Types.ParagraphElementType, asset?: { __typename?: 'BlobRef', contentType: string, fileName: string, originalFileName?: string | null, uri: any } | null }> }> }> } };

export type SearchParagraphsByRegDocIdQueryVariables = Types.Exact<{
  regulatoryDocumentId: Types.Scalars['ID'];
  searchString: Types.Scalars['String'];
}>;


export type SearchParagraphsByRegDocIdQuery = { __typename?: 'Query', searchParagraphsForRegDoc: Array<{ __typename?: 'RegulatoryDocumentParagraph', id: string }> };


export const FullTextSearchRegulationsDocument = gql`
    query FullTextSearchRegulations($searchString: String!, $limit: Int) {
  searchRegulations(searchString: $searchString, limit: $limit) {
    regulations {
      ...BasicRegulationFields
    }
  }
}
    ${BasicRegulationFieldsFragmentDoc}`;

/**
 * __useFullTextSearchRegulationsQuery__
 *
 * To run a query within a React component, call `useFullTextSearchRegulationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFullTextSearchRegulationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFullTextSearchRegulationsQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFullTextSearchRegulationsQuery(baseOptions: Apollo.QueryHookOptions<FullTextSearchRegulationsQuery, FullTextSearchRegulationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FullTextSearchRegulationsQuery, FullTextSearchRegulationsQueryVariables>(FullTextSearchRegulationsDocument, options);
      }
export function useFullTextSearchRegulationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FullTextSearchRegulationsQuery, FullTextSearchRegulationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FullTextSearchRegulationsQuery, FullTextSearchRegulationsQueryVariables>(FullTextSearchRegulationsDocument, options);
        }
export type FullTextSearchRegulationsQueryHookResult = ReturnType<typeof useFullTextSearchRegulationsQuery>;
export type FullTextSearchRegulationsLazyQueryHookResult = ReturnType<typeof useFullTextSearchRegulationsLazyQuery>;
export type FullTextSearchRegulationsQueryResult = Apollo.QueryResult<FullTextSearchRegulationsQuery, FullTextSearchRegulationsQueryVariables>;
export const FullTextSearchRegulatoryDocumentsDocument = gql`
    query FullTextSearchRegulatoryDocuments($searchString: String!, $limit: Int) {
  searchRegulatoryDocuments(searchString: $searchString, limit: $limit) {
    regulatoryDocuments {
      ...BasicRegulatoryDocumentFields
    }
  }
}
    ${BasicRegulatoryDocumentFieldsFragmentDoc}`;

/**
 * __useFullTextSearchRegulatoryDocumentsQuery__
 *
 * To run a query within a React component, call `useFullTextSearchRegulatoryDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFullTextSearchRegulatoryDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFullTextSearchRegulatoryDocumentsQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFullTextSearchRegulatoryDocumentsQuery(baseOptions: Apollo.QueryHookOptions<FullTextSearchRegulatoryDocumentsQuery, FullTextSearchRegulatoryDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FullTextSearchRegulatoryDocumentsQuery, FullTextSearchRegulatoryDocumentsQueryVariables>(FullTextSearchRegulatoryDocumentsDocument, options);
      }
export function useFullTextSearchRegulatoryDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FullTextSearchRegulatoryDocumentsQuery, FullTextSearchRegulatoryDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FullTextSearchRegulatoryDocumentsQuery, FullTextSearchRegulatoryDocumentsQueryVariables>(FullTextSearchRegulatoryDocumentsDocument, options);
        }
export type FullTextSearchRegulatoryDocumentsQueryHookResult = ReturnType<typeof useFullTextSearchRegulatoryDocumentsQuery>;
export type FullTextSearchRegulatoryDocumentsLazyQueryHookResult = ReturnType<typeof useFullTextSearchRegulatoryDocumentsLazyQuery>;
export type FullTextSearchRegulatoryDocumentsQueryResult = Apollo.QueryResult<FullTextSearchRegulatoryDocumentsQuery, FullTextSearchRegulatoryDocumentsQueryVariables>;
export const FullTextSearchRequirementsDocument = gql`
    query FullTextSearchRequirements($searchString: String!, $limit: Int) {
  searchRequirements(searchString: $searchString, limit: $limit) {
    requirements {
      ...BasicRequirementFields
    }
  }
}
    ${BasicRequirementFieldsFragmentDoc}`;

/**
 * __useFullTextSearchRequirementsQuery__
 *
 * To run a query within a React component, call `useFullTextSearchRequirementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFullTextSearchRequirementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFullTextSearchRequirementsQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFullTextSearchRequirementsQuery(baseOptions: Apollo.QueryHookOptions<FullTextSearchRequirementsQuery, FullTextSearchRequirementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FullTextSearchRequirementsQuery, FullTextSearchRequirementsQueryVariables>(FullTextSearchRequirementsDocument, options);
      }
export function useFullTextSearchRequirementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FullTextSearchRequirementsQuery, FullTextSearchRequirementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FullTextSearchRequirementsQuery, FullTextSearchRequirementsQueryVariables>(FullTextSearchRequirementsDocument, options);
        }
export type FullTextSearchRequirementsQueryHookResult = ReturnType<typeof useFullTextSearchRequirementsQuery>;
export type FullTextSearchRequirementsLazyQueryHookResult = ReturnType<typeof useFullTextSearchRequirementsLazyQuery>;
export type FullTextSearchRequirementsQueryResult = Apollo.QueryResult<FullTextSearchRequirementsQuery, FullTextSearchRequirementsQueryVariables>;
export const FullTextSearchPogisDocument = gql`
    query FullTextSearchPogis($searchString: String!, $limit: Int) {
  searchPogisDocuments(searchString: $searchString, limit: $limit) {
    pogisDocuments {
      ...BasicPogisFields
    }
  }
}
    ${BasicPogisFieldsFragmentDoc}`;

/**
 * __useFullTextSearchPogisQuery__
 *
 * To run a query within a React component, call `useFullTextSearchPogisQuery` and pass it any options that fit your needs.
 * When your component renders, `useFullTextSearchPogisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFullTextSearchPogisQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFullTextSearchPogisQuery(baseOptions: Apollo.QueryHookOptions<FullTextSearchPogisQuery, FullTextSearchPogisQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FullTextSearchPogisQuery, FullTextSearchPogisQueryVariables>(FullTextSearchPogisDocument, options);
      }
export function useFullTextSearchPogisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FullTextSearchPogisQuery, FullTextSearchPogisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FullTextSearchPogisQuery, FullTextSearchPogisQueryVariables>(FullTextSearchPogisDocument, options);
        }
export type FullTextSearchPogisQueryHookResult = ReturnType<typeof useFullTextSearchPogisQuery>;
export type FullTextSearchPogisLazyQueryHookResult = ReturnType<typeof useFullTextSearchPogisLazyQuery>;
export type FullTextSearchPogisQueryResult = Apollo.QueryResult<FullTextSearchPogisQuery, FullTextSearchPogisQueryVariables>;
export const DeepSearchParagraphsDocument = gql`
    query DeepSearchParagraphs($searchString: String!) {
  searchParagraphs(searchString: $searchString) {
    regulatoryDocumentsOtherData {
      id
      name
      regulation {
        id
        name
        regulationNumber
      }
      paragraphs {
        level
        id
        enumeration
      }
    }
    regulatoryDocumentsSearchedPara {
      id
      paragraphs {
        ...BasicRegulatoryDocumentParaFields
      }
    }
  }
}
    ${BasicRegulatoryDocumentParaFieldsFragmentDoc}`;

/**
 * __useDeepSearchParagraphsQuery__
 *
 * To run a query within a React component, call `useDeepSearchParagraphsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeepSearchParagraphsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeepSearchParagraphsQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *   },
 * });
 */
export function useDeepSearchParagraphsQuery(baseOptions: Apollo.QueryHookOptions<DeepSearchParagraphsQuery, DeepSearchParagraphsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeepSearchParagraphsQuery, DeepSearchParagraphsQueryVariables>(DeepSearchParagraphsDocument, options);
      }
export function useDeepSearchParagraphsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeepSearchParagraphsQuery, DeepSearchParagraphsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeepSearchParagraphsQuery, DeepSearchParagraphsQueryVariables>(DeepSearchParagraphsDocument, options);
        }
export type DeepSearchParagraphsQueryHookResult = ReturnType<typeof useDeepSearchParagraphsQuery>;
export type DeepSearchParagraphsLazyQueryHookResult = ReturnType<typeof useDeepSearchParagraphsLazyQuery>;
export type DeepSearchParagraphsQueryResult = Apollo.QueryResult<DeepSearchParagraphsQuery, DeepSearchParagraphsQueryVariables>;
export const SearchParagraphsByRegDocIdDocument = gql`
    query SearchParagraphsByRegDocId($regulatoryDocumentId: ID!, $searchString: String!) {
  searchParagraphsForRegDoc(
    regulatoryDocumentID: $regulatoryDocumentId
    searchString: $searchString
  ) {
    id
  }
}
    `;

/**
 * __useSearchParagraphsByRegDocIdQuery__
 *
 * To run a query within a React component, call `useSearchParagraphsByRegDocIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchParagraphsByRegDocIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchParagraphsByRegDocIdQuery({
 *   variables: {
 *      regulatoryDocumentId: // value for 'regulatoryDocumentId'
 *      searchString: // value for 'searchString'
 *   },
 * });
 */
export function useSearchParagraphsByRegDocIdQuery(baseOptions: Apollo.QueryHookOptions<SearchParagraphsByRegDocIdQuery, SearchParagraphsByRegDocIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchParagraphsByRegDocIdQuery, SearchParagraphsByRegDocIdQueryVariables>(SearchParagraphsByRegDocIdDocument, options);
      }
export function useSearchParagraphsByRegDocIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchParagraphsByRegDocIdQuery, SearchParagraphsByRegDocIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchParagraphsByRegDocIdQuery, SearchParagraphsByRegDocIdQueryVariables>(SearchParagraphsByRegDocIdDocument, options);
        }
export type SearchParagraphsByRegDocIdQueryHookResult = ReturnType<typeof useSearchParagraphsByRegDocIdQuery>;
export type SearchParagraphsByRegDocIdLazyQueryHookResult = ReturnType<typeof useSearchParagraphsByRegDocIdLazyQuery>;
export type SearchParagraphsByRegDocIdQueryResult = Apollo.QueryResult<SearchParagraphsByRegDocIdQuery, SearchParagraphsByRegDocIdQueryVariables>;